import FormattedMessage from 'I18n/components/FormattedMessage';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { Link } from 'foundations-components/transitional/components/Link';
import { getI18nText } from 'pricing-pages-lib/utils/languageUtils';
import { getSuiteLegalDisclaimerUrl } from 'pricing-pages-lib/utils/urls';
import { PageSubTitle } from 'pricing-pages-ui-components/semantic/PageHeader';
import { useSelector } from 'react-redux';
import { COMMERCE } from 'self-service-api/constants/EnrolledProductLines';
import { CMS, MARKETING, OPERATIONS, SALES, SERVICE } from 'self-service-api/constants/ProductLines';
import { NavItemEnum } from '../../constants/routing/NavItems';
import { PRODUCT_PAGE_HEADER } from '../../constants/tracking/TrackingSources';
import { isAppAuthSelector } from '../../selectors/AuthSelectors';
import { isUngatedForSeatsSelector } from '../../selectors/GatingSelectors';
import { trackClickedLink } from '../../utils/tracking/trackingEventUtils';
import CalculatorAnchorLink from './CalculatorAnchorLink';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ProductPageSubtitle = ({
  productLine,
  nonProductIdentifier
}) => {
  const isUngatedForSeats = useSelector(isUngatedForSeatsSelector);
  const isAppAuth = useSelector(isAppAuthSelector);
  const showCalculatorLink = !isAppAuth;
  if (nonProductIdentifier === NavItemEnum.COMMERCE) {
    productLine = COMMERCE;
  }
  const handleLegalLinkClick = () => {
    trackClickedLink({
      name: 'legal-stuff',
      value: getI18nText('pricingPage.pages.suite.details', {
        locale: 'en-us'
      }),
      type: 'external',
      url: getSuiteLegalDisclaimerUrl(),
      trackingSource: PRODUCT_PAGE_HEADER,
      screen: NavItemEnum.SUITE
    });
  };
  const translationKeyMap = {
    [MARKETING]: 'pricingPage.pages.products.tabs.marketing.description',
    [SALES]: 'pricingPage.pages.products.tabs.sales.description',
    [SERVICE]: 'pricingPage.pages.products.tabs.service.description',
    [CMS]: 'pricingPage.pages.products.tabs.cms.description',
    [OPERATIONS]: 'pricingPage.pages.products.tabs.operations.description',
    [COMMERCE]: 'pricingPage.pages.products.tabs.commerce.description',
    [NavItemEnum.SMART_CRM]: 'pricingPage.pages.products.tabs.smart-crm.description',
    [NavItemEnum.BUNDLE]: 'pricingPage.pages.products.tabs.bundle.description',
    [NavItemEnum.FREE]: 'pricingPage.pages.products.tabs.crm.description',
    [NavItemEnum.MARKETING_PLUS]: 'pricingPage.pages.products.tabs.marketing-plus.description',
    [NavItemEnum.BREEZE_INTELLIGENCE]: 'pricingPage.pages.products.tabs.breeze-intelligence.description'
  };
  return /*#__PURE__*/_jsx(PageSubTitle, {
    children: nonProductIdentifier === NavItemEnum.SUITE ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricingPage.pages.suite.subtitle"
      }), !isUngatedForSeats ? /*#__PURE__*/_jsx(Link, {
        external: true,
        href: getSuiteLegalDisclaimerUrl(),
        onClick: handleLegalLinkClick,
        marginInlineStart: "100",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.pages.suite.details"
        })
      }) : /*#__PURE__*/_jsx(_Fragment, {
        children: showCalculatorLink && /*#__PURE__*/_jsx(CalculatorAnchorLink, {})
      }), !isUngatedForSeats ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(HelpIcon, {
          size: "small",
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "pricingPage.pages.suite.freeUsersTooltip"
          }),
          marginInlineEnd: "200",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "pricingPage.pages.suite.unlimitedFreeUsers"
          })
        }), showCalculatorLink && /*#__PURE__*/_jsx(CalculatorAnchorLink, {})]
      }) : null]
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [productLine && translationKeyMap[productLine] && /*#__PURE__*/_jsx(FormattedMessage, {
        message: translationKeyMap[productLine]
      }), nonProductIdentifier && translationKeyMap[nonProductIdentifier] && /*#__PURE__*/_jsx(FormattedMessage, {
        message: translationKeyMap[nonProductIdentifier]
      }), showCalculatorLink && nonProductIdentifier !== NavItemEnum.FREE && nonProductIdentifier !== NavItemEnum.BUNDLE && nonProductIdentifier !== NavItemEnum.BREEZE_INTELLIGENCE && nonProductIdentifier !== NavItemEnum.SMART_CRM && productLine !== COMMERCE && /*#__PURE__*/_jsx(CalculatorAnchorLink, {
        productLine: productLine,
        nonProductIdentifier: nonProductIdentifier
      })]
    })
  });
};
export default ProductPageSubtitle;